<script setup>
import { useScheduleItemStore } from "@/stores/ScheduleItemStore"

    const store = useScheduleItemStore()

    const clearFilters = () => {
        store.clearAllFilters()
    }
    
</script>
<template>
    <div class="schedule-item no-results is-plenary">
        
        <div class="schedule-item__info">

            <div class="schedule-item__info__content">
                
                <p>
                    You've searched for "<strong>{{store.currentFilters.search}}</strong>".<br />
                    We couldn't find a presenter or presentation for this query.                    
                </p>

            </div>
            <div class="schedule-item__info__more">
                <span
                    class="clear-all-filters"
                    @click.prevent="clearFilters()"
                >Clear the search</span> or try another query.
            </div>
        </div>
        
    </div>
</template>



